import { useMediaQuery } from 'react-responsive';
import { DESKTOP_SIZE, TABLET_SIZE, LANDSCAPE_PHONE_SIZE, LARGE_DESKTOP_SIZE } from '../../utils/useScreenInfo';
import React from 'react';
import { Dimensions } from 'react-native';

export const DesktopAndLarger = ({ children }) => {
    const isDesktop = useMediaQuery({ minWidth: DESKTOP_SIZE })
    return isDesktop ? children : null
}
export const TabletAndLarger = ({ children }) => {
    const isTablet = useMediaQuery({ minWidth: TABLET_SIZE })
    return isTablet ? children : null
}
export const MobileAndLarger = ({ children }) => {
    const isMobile = useMediaQuery({ minWidth: LANDSCAPE_PHONE_SIZE  })
    return isMobile ? children : null
}

export const Tablet = ({ children }) => {
    const isTablet = useMediaQuery({ minWidth: TABLET_SIZE, maxWidth: DESKTOP_SIZE })
    return isTablet ? children : null
}
export const Mobile = ({ children }) => {
    const isMobile = useMediaQuery({ minWidth: LANDSCAPE_PHONE_SIZE, maxWidth: TABLET_SIZE  })
    return isMobile ? children : null
}
export const MobileOrTabletAndLarger = ({ mobile, tabletAndLarger }) => {
    const isTablet = useMediaQuery({ minWidth: TABLET_SIZE })
    return isTablet ? tabletAndLarger :  mobile;
}



// export const Default = ({ children }) => {
//     const isNotMobile = useMediaQuery({ minWidth: 768 })
//     return isNotMobile ? children : null
// }
